<template>
  <form-row>
    <div class="form-field">
      <h2>{{ i18n.t('member.campaigns.form.staff_led_campaign_title') }}</h2>
      <toggle id="staff-led-campaign" :initial-value="value" field="staff_led_campaign" :label="i18n.t('member.campaigns.form.staff_led_campaign_label')"
              :validation-errors="validationErrors" @change="updateStaffLedCampaign" />
    </div>
  </form-row>
</template>

<script>
import FieldMixin from './field-mixin'
import FormRow from '@/campaign-form-shared/form-row'
import Toggle from '@/components/inputs/toggle'
import { mapMutations, mapState } from 'vuex'

export default {
  components: { FormRow, Toggle },

  mixins: [ FieldMixin ],

  computed: {
    ...mapState({
      validationErrorsByField: 'validationErrors'
    }),

    validationErrors() {
      return this.validationErrorsByField.staffLedCampaign
    }
  },

  methods: {
    ...mapMutations(['setStaffLedCampaign']),

    updateStaffLedCampaign({ value }) {
      this.setStaffLedCampaign(value)
    }
  }
}
</script>

<style scoped>
::v-deep(.toggle-label-text) {
  font-size: 20px;
}
</style>
